// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-page{border-radius:6px;border:1px solid rgba(14,93,201,0.2);background:#FFF;padding:1.5rem;position:relative}\n", ""]);
// Exports
module.exports = exports;
